import React, { useState } from "react";
import { RotateCcw } from "lucide-react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

// Small "Reset" chip with an in-app confirm; clears everything filled in on the current panel.
export default function ResetButton({ onReset, testid = "panel-reset-button", label = "Reset panel", className = "" }) {
  const [ask, setAsk] = useState(false);
  if (!onReset) return null;
  return (
    <>
      <button type="button" onClick={() => setAsk(true)} data-testid={testid} title="Clear everything filled in here and start fresh"
        className={`ax-chip hover:!border-amber-500/50 hover:!text-amber-200 ${className}`}><RotateCcw className="w-3.5 h-3.5" />{label}</button>
      <AlertDialog open={ask} onOpenChange={setAsk}>
        <AlertDialogContent className="bg-[#0E1114] border-zinc-800 text-zinc-100" data-testid={`${testid}-confirm`}>
          <AlertDialogHeader>
            <AlertDialogTitle>Reset this panel?</AlertDialogTitle>
            <AlertDialogDescription className="text-zinc-400">Everything you filled in here is cleared so you can start fresh. Your history and files stay.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel className="bg-transparent border-zinc-700 text-zinc-300" data-testid={`${testid}-cancel`}>Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={() => onReset()} className="bg-amber-500 text-black hover:bg-amber-400" data-testid={`${testid}-yes`}>Reset</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
